import {Grid, Group, NumberInput, RingProgress, Stack, Text} from "@mantine/core"
import {useForm} from "@mantine/form";
import {NumberUtils} from "utils";
import {useEffect} from "react";
import {LoaderDefault} from "components/common";

interface Props {
    value: number
    loading?: boolean
    currentHomeMortgageValue?:string,
}

export function HomeEquityCalculator({value, currentHomeMortgageValue, loading = true}: Props) {
    const form = useForm<{ homeValue: number, mortgageBalance: number }>({
        initialValues: {
            homeValue: value,
            mortgageBalance: currentHomeMortgageValue ? parseFloat(currentHomeMortgageValue) : (value * 0.75)
        },
        validate: {},
    })

    useEffect(() => {
        if (!loading && value) {
            form.setFieldValue('homeValue', value)
            form.setFieldValue('mortgageBalance', currentHomeMortgageValue ? parseFloat(currentHomeMortgageValue) : (value * 0.75))
        }
    }, [loading, value]);

    function percentageEquity() {
        return Math.round((form.values.mortgageBalance / form.values.homeValue) * 100)
    }

    if (loading){
        return <LoaderDefault text="Loading Equity"/>
    }

    return (
        <Grid>
            <Grid.Col span={8}>
                <Group position="center">
                    <RingProgress
                        size={200}
                        roundCaps
                        thickness={10}
                        sections={[{value: 100 - percentageEquity(), color: "blue"}]}
                        label={
                            <Stack align="center" spacing={0}>
                                <Text weight={700} align="center" size="xl">
                                    {NumberUtils.formatAsCurrency(form.values.homeValue - form.values.mortgageBalance)}
                                </Text>
                                <Text size="xs">
                                    Est. Home Equity
                                </Text>
                            </Stack>
                        }
                    />
                </Group>
            </Grid.Col>
            <Grid.Col span={4}>
                <form style={{height: "100%", width:"100%", display:"flex"}}>
                    <Stack justify="center" w="100%">
                        <NumberInput
                            hideControls
                            parser={(value) => (value as string).replace(/\$\s?|(,*)/g, '')}
                            formatter={(value) =>
                                !Number.isNaN(parseFloat(value as string))
                                    ? `$ ${value}`.replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                                    : '$ '
                            }
                            label="Home Value" {...form.getInputProps('homeValue')}/>
                        <NumberInput
                            hideControls
                            parser={(value) => (value as string).replace(/\$\s?|(,*)/g, '')}
                            formatter={(value) =>
                                !Number.isNaN(parseFloat(value as string))
                                    ? `$ ${value}`.replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                                    : '$ '
                            }
                            label="Mortgage Balance" {...form.getInputProps('mortgageBalance')}/>
                    </Stack>
                </form>
            </Grid.Col>
        </Grid>
    )
}